import { useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetStressAssessmentResult = (
  threeLetterCode: string,
  stressAssessmentId: number,
  userId: number,
  options?: Parameters<
    typeof useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId
  >[3]
) => {
  return useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsStressAssessmentIdResultsId(
    threeLetterCode,
    stressAssessmentId,
    userId,
    options
  );
};
